import React, { FunctionComponent } from 'react';

import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type WarningMessageModalProps = {
    isMulti?: boolean;
    onDecision: (publish: boolean) => void;
};

const AlertSVG = () => (
    <svg
        className="alert-icon"
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M19.7809 15.4781L11.4716 1.27821C11.1205 0.732059 10.5744 0.458984 10.0282 0.458984C9.44305 0.458984 8.8969 0.732059 8.5458 1.27821L0.197522 15.4781C-0.387638 16.5704 0.392575 17.9358 1.67993 17.9358H18.3375C19.6248 17.9358 20.405 16.5704 19.7809 15.4781ZM2.07003 16.0632L9.9892 2.52655L17.9474 16.0632H2.07003ZM10.0282 12.3962C9.32601 12.3962 8.77987 12.9424 8.77987 13.6056C8.77987 14.2688 9.32601 14.8149 10.0282 14.8149C10.6914 14.8149 11.2375 14.2688 11.2375 13.6056C11.2375 12.9424 10.6914 12.3962 10.0282 12.3962ZM9.09195 6.3886V10.1336C9.09195 10.6798 9.48206 11.0699 10.0282 11.0699C10.5353 11.0699 10.9645 10.6798 10.9645 10.1336V6.3886C10.9645 5.88147 10.5353 5.45235 10.0282 5.45235C9.48206 5.45235 9.09195 5.88147 9.09195 6.3886Z" />
    </svg>
);

export const WarningMessageModal: FunctionComponent<WarningMessageModalProps> = ({ isMulti, onDecision }) => {
    const { t } = useTranslation(['common/response-editor']);
    const message = t(`WARNING_CONTENT_POST_APPROVING_${isMulti ? 'MULTI' : 'SINGLE'}`);

    return (
        <Modal show centered>
            <Modal.Header>
                <Modal.Title>
                    <div className="warning-title-modal">
                        <AlertSVG />
                        {t('WARNING_TITLE')}
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className="warning-message-modal">{message}</span>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-tool-bar-generate" variant="outline-primary" onClick={() => onDecision(false)}>
                    {t('CANCEL')}
                </Button>
                <Button className="btn btn-danger" variant="" onClick={() => onDecision(true)}>
                    {t('PUBLISH_ANYWAY')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
